import { MetricsRow, MetricsSpace } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import DurationService from "app/services/DurationService";

import {
    SearchOverviewTopOrganicKeywordsCompare,
    SearchOverviewTopPaidKeywordsCompare,
} from "../SearchOverviewTraffic/SearchOverviewTrafficTablesCompare";
import { MetricContainer } from "../SearchOverviewTraffic/StyledComponent";

const metricHeight = "330px";
const metricMarginTop = "24px";
const metricWidth = "50%";

export const SearchOverviewTrafficCompare = (props) => {
    const { country, isWWW, duration, key, webSource } = props.params;
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const queryParams = {
        country,
        from,
        includeSubDomains: isWWW === "*",
        isWindow,
        keys: key,
        to,
        webSource,
        timeGranularity: "Monthly",
    };
    return (
        <MetricsRow marginTop={metricMarginTop}>
            <MetricContainer
                height={metricHeight}
                width={metricWidth}
            >
                <SearchOverviewTopOrganicKeywordsCompare
                    queryParams={queryParams}
                    routingParams={props.params}
                />
            </MetricContainer>
            <MetricsSpace />
            <MetricContainer
                height={metricHeight}
                width={metricWidth}
            >
                <SearchOverviewTopPaidKeywordsCompare
                    queryParams={queryParams}
                    routingParams={props.params}
                />
            </MetricContainer>
        </MetricsRow>
    );
};
